<template>
    <div class="title-content">
        <h2>{{h2}} /</h2>
        <h1>{{h1}}</h1>
    </div>
</template>

<script>
export default {
  name: "TitleContent",  
  data: () => ({
  }),
  props: { h2: String, h1:String },
};
</script>


<style lang="scss" scoped>
h2 {
    color: #B2B3B8;
    font-family: 'Gotham';
    font-size: 0.9em;
    font-weight: 500;
    letter-spacing: 0;
}
h1 {
    color: #FFFFFF;
    font-family: 'Gotham';
    font-size: 1.9em;
    font-weight: 900;
    letter-spacing: 0;
}
.title-content {
    position: relative;
    padding-bottom:1.5em;
    border-bottom:1px solid white;    
    margin-bottom:2.5em;
}
</style>
